import { select } from 'redux-saga/effects';
import { createAsyncAction } from 'typesafe-actions';

import { ResourceLite } from '../resources/createResource';
import { EntityBase, EntityID } from '../resources/types';

import sagaApi, { Meta, PayloadApiFailure, PayloadApiRequest, PayloadApiSuccess } from './sagaApi';
import sagaHandleCached from './sagaHandleCached';

export interface FetchPayload<E extends EntityBase> extends PayloadApiRequest<E> {
  resource: ResourceLite<E>;
  method?: 'get';
  id: EntityID;
  meta?: Meta<E> & {
    forceFetch?: boolean;
  };
}

const fetch = createAsyncAction('@lib/fetch/REQUEST', '@lib/fetch/SUCCESS', '@lib/fetch/FAILURE', '@lib/fetch/CANCEL')<
  FetchPayload<any>,
  PayloadApiSuccess<any>,
  PayloadApiFailure,
  any
>();

// saga
export function* sagaFetch(action: ReturnType<typeof fetch.request>) {
  const { payload } = action;
  const { id, resource, meta = {} } = payload;
  const { forceFetch, ...restMeta } = meta;

  // @ts-ignore
  const entityCached = yield select(resource.makeSelectEntityWithoutLookups(id));
  if (entityCached && !forceFetch) {
    // @ts-ignore
    return yield sagaHandleCached({
      action: fetch,
      result: entityCached.id,
      data: entityCached,
      payload,
    });
  }

  // @ts-ignore
  return yield sagaApi({
    action: fetch,
    url: `${resource.url}/${id}`,
    ...payload,
    meta: {
      schema: resource.fetchSchema,
      ...restMeta,
    },
  });
}

export default fetch;
